import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export interface CouponSuccess {
  code: string;
  status: true;
}

export interface CouponFailed {
  code: string;
  status: false;
  error: string;
}

export const trackCouponInsertedEvent = (params: CouponSuccess | CouponFailed) =>
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.COUPON_INSERTED,
      coupon: params.status
        ? {
            action: EcommerceSectionNamespace.EEcommerceCouponAction.COUPON_INSERT_OK,
            name: params.code,
            interaction: EcommerceSectionNamespace.EEcommerceInteraction.BUTTON,
            type: EcommerceSectionNamespace.EEcommerceCouponType.COUPON,
            status: EcommerceSectionNamespace.EEcommerceStatus.OK,
          }
        : {
            action: EcommerceSectionNamespace.EEcommerceCouponAction.COUPON_INSERT_FAILED,
            name: params.code,
            status: params.error,
            interaction: EcommerceSectionNamespace.EEcommerceInteraction.BUTTON,
            type: EcommerceSectionNamespace.EEcommerceCouponType.COUPON,
          },
      _clear: true,
    }),
  );
